// extracted by mini-css-extract-plugin
export var activeDot = "_4x-c";
export var buttonContainer = "_4x-9";
export var channelButton = "_4x-a";
export var clickable = "_4x-d";
export var content = "_4x-0";
export var contentFull = "_4x-2";
export var contentThird = "_4x-1";
export var contentWrapper = "_4x-7";
export var description = "_4x-5";
export var heightShort = "_4x-f";
export var image = "_4x-3";
export var imageContainer = "_4x-4";
export var selectButton = "_4x-e";
export var spinnerContainer = "_4x-b";
export var titleContent = "_4x-8";
export var titleWrapper = "_4x-6";